import { createContext, useContext, useMemo, useState, useEffect } from "react";
import { Backdrop, Box, Button, Fade, Modal, Typography, styled } from "@mui/material";
import { useLocation } from "react-router";

import SuccessIcon from "../Images/SuccessIcon.gif";
import ErrorGif from "../Images/errorGif.gif";
import WarningGif from "../Images/warninggif.gif";
import { popupType } from "../common/constant";

const BoxWrapperstyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  backgroundColor: theme.palette.background.default,
  padding: "30px 35px 34px",
  borderRadius: "15px",
  textAlign: "center",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& h3": {
    color: theme.palette.text.primary,
    fontWeight: 600,
    margin: "15px 0",
    border: "1px solid #00000014",
    padding: "10px 0",

    "& .inprogress": {
      color: "green",
      fontSize: "10px",
    },
  },
  "& img": {
    width: "50px",
    mb: "10px",
  },
  "& h2": { fontSize: "18px", fontWeight: "600", color: theme.palette.text.primary, marginBottom: "10px" },
  "& p": { fontSize: "16px", marginBottom: "18px", color: theme.palette.text.primary, fontWeight: "600" },
  "& button": {
    boxShadow: "none",
    textTransform: "none",
    backgroundColor: "green",
    color: "#fff",
    borderRadius: "7px",
    padding: "6px 24px 6px",
    width: "100%",
    fontSize: "16px",
    "&.ErrorBtn": {
      backgroundColor: "#ff0000",
      color: "#ffffff",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
      color: "#fff",
    },
    "&:focus": {
      outline: "none",
    },
  },
}));

const PopupContext = createContext();

function Popupprovider({ children }) {
  const location = useLocation();
  const isRegisterPage = location.pathname === "/register";
  const [open, setOpen] = useState(false);
  const [popupLink, setPopupLink] = useState(null);
  const [newPopUpState, setNewPopUpState] = useState({ isOpen: false, buttonType: popupType.success, contentFunc: () => "" });
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setOpen(false);
    setNewPopUpState({ isOpen: false, contentFunc: () => "" });
  };
  const handleOpen = (op, msg, link = null) => {
    setOpen(op);
    setMessage(msg);
    setPopupLink(link);

    if (!op) {
      handleClose();
    }
  };

  const customPopupModel = ({ isOpen = true, buttonType, type, contentFunc = () => "" }) => {
    setNewPopUpState({ isOpen, type, contentFunc, buttonType });
  };

  const contextData = useMemo(() => ({ handleOpen, customPopupModel }), [handleOpen]);
  useEffect(() => {
    const handleKeyPress = event => {
      if (event.key === "Enter" && (open || newPopUpState?.isOpen)) {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [open, newPopUpState?.isOpen]);
  useEffect(() => {
    setOpen(false);
    setNewPopUpState({ isOpen: false, buttonType: popupType.success, contentFunc: () => "" });
    handleClose();
  }, [location.pathname]);
  return (
    <PopupContext.Provider value={contextData}>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{
          backdrop: Backdrop,
        }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <BoxWrapperstyle>
            <Typography component="p">{message}</Typography>
            {popupLink && (
              <Typography
                component="a"
                href={popupLink}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "block",
                  marginBottom: "10px",
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                View Published Post
              </Typography>
            )}
            <Button variant="contained" onClick={handleClose}>
              Ok
            </Button>
          </BoxWrapperstyle>
        </Fade>
      </Modal>
      <Modal
        open={newPopUpState?.isOpen}
        onClose={isRegisterPage ? undefined : handleClose}
        closeAfterTransition
        slots={{
          backdrop: Backdrop,
        }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={newPopUpState?.isOpen}>
          <BoxWrapperstyle>
            {newPopUpState.type === popupType.success ? <Typography component="img" src={SuccessIcon} alt="successGif" /> : ""}
            {newPopUpState.type === popupType.emoji && newPopUpState.buttonType === popupType.success ? (
              <Typography component="p" sx={{ fontSize: "30px !important", marginBottom: "10px !important" }}>
                😊
              </Typography>
            ) : (
              ""
            )}
            {newPopUpState.type === popupType.failed ? <Typography component="img" src={ErrorGif} alt="ErrorGif" /> : ""}
            {newPopUpState.type === popupType.warning ? <Typography component="img" src={WarningGif} alt="WarningGif" /> : ""}
            <Box sx={{ marginBottom: "10px !important" }}> {newPopUpState?.contentFunc}</Box>
            {newPopUpState.buttonType === popupType.failed ? (
              <Button variant="contained" className="ErrorBtn" onClick={handleClose}>
                Ok
              </Button>
            ) : (
              ""
            )}
            {newPopUpState.buttonType === popupType.success ? (
              <Button variant="contained" className="okButton" onClick={handleClose}>
                Ok
              </Button>
            ) : (
              ""
            )}
          </BoxWrapperstyle>
        </Fade>
      </Modal>
      {children}
    </PopupContext.Provider>
  );
}

export default Popupprovider;

export const usePopup = () => useContext(PopupContext);
